import { render } from "./HeaderFaq.vue?vue&type=template&id=023253d8&scoped=true&lang=true"
import script from "./HeaderFaq.vue?vue&type=script&lang=js"
export * from "./HeaderFaq.vue?vue&type=script&lang=js"

import "./HeaderFaq.vue?vue&type=style&index=0&id=023253d8&scoped=true&lang=scss"

import exportComponent from "/var/www/orikomi-exclusive-cart-test.107.jp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023253d8"]])

export default __exports__